/**
 * dialogFx.js v1.0.0
 * http://www.codrops.com
 *
 * Licensed under the MIT license.
 * http://www.opensource.org/licenses/mit-license.php
 * 
 * Copyright 2014, Codrops
 * http://www.codrops.com
 */
;
(function(window) {

    var $ = require('jquery');

    'use strict';

    var support = {
            animations: Modernizr.cssanimations
        },
        animEndEventNames = {
            'WebkitAnimation': 'webkitAnimationEnd',
            'OAnimation': 'oAnimationEnd',
            'msAnimation': 'MSAnimationEnd',
            'animation': 'animationend'
        },
        animEndEventName = animEndEventNames[Modernizr.prefixed('animation')],
        onEndAnimation = function(el, callback) {
            var onEndCallbackFn = function(ev) {
                if (support.animations) {
                    if (ev.target != this) return;
                    this.removeEventListener(animEndEventName, onEndCallbackFn);
                }
                if (callback && typeof callback === 'function') {
                    callback.call();
                }
            };
            if (support.animations) {
                el.addEventListener(animEndEventName, onEndCallbackFn);
            } else {
                onEndCallbackFn();
            }
        };

    function extend(a, b) {
        for (var key in b) {
            if (b.hasOwnProperty(key)) {
                a[key] = b[key];
            }
        }
        return a;
    }

    function DialogFx(el, options) {
        this.el = el;
        this.options = extend({}, this.options);
        extend(this.options, options);
        this.ctrlClose = this.el.querySelector('[data-dialog-close]');
        this.isOpen = false;
        this._initEvents();
    }

    DialogFx.prototype.options = {
        // callbacks
        onOpenDialog: function() {
            // console.log('has been opened');
            hidegift();
            return false;
        },
        onCloseDialog: function() {
            // console.log('has been closed');
            showgift();
            return false;
        }
    }

    function hidegift() {
        // console.log('gift is hidden');
        $('.sidefixed').addClass('hide');
    }


    function showgift() {
        // console.log('gift is shown');
        $('.sidefixed').removeClass('hide');
        $('.sidefixed img').addClass('rubberBand infinite');
    }

    DialogFx.prototype._initEvents = function() {
        var self = this;

        // close action
        this.ctrlClose.addEventListener('click', function() {
            // this.toggle.bind(this);
            self.toggle(); // $('.audio_player').html('');
        });

        // esc key closes dialog
        document.addEventListener('keydown', function(ev) {
            var keyCode = ev.keyCode || ev.which;
            if (keyCode === 27 && self.isOpen) {
                self.toggle();
                $('.audio_player').html('');
            }
        });

        this.el.querySelector('.dialog__overlay').addEventListener('click', this.toggle.bind(this));

        // $('.sidefixed').click(function() {
        //     self.toggle();
        // });
    }




    DialogFx.prototype.toggle = function() {
        var self = this;
        if (this.isOpen) {
            classie.remove(this.el, 'dialog--open');
            classie.add(self.el, 'dialog--close');
            onEndAnimation(this.el.querySelector('.dialog__content'), function() {
                classie.remove(self.el, 'dialog--close');
            });
            // callback on close
            this.options.onCloseDialog(this);
        } else {
            classie.add(this.el, 'dialog--open');
            // callback on open
            this.options.onOpenDialog(this);
        }
        this.isOpen = !this.isOpen;
    };






    // add to global namespace
    window.DialogFx = DialogFx;

    function opendialog() {
        var dlgtrigger = document.querySelector('[data-dialog]'),
            somedialog = document.getElementById(dlgtrigger.getAttribute('data-dialog'));
        var dlg = new DialogFx(somedialog);
        dlgtrigger.addEventListener('click', dlg.toggle.bind(dlg));
        // dlgtrigger.click();
        var popupaudio = '<audio  autoplay id="playAudio"><source src="' + themeURL + 'media/Ramadan.mp3" type="audio/mp3" ver1></audio>'
        $('.audio_player').html('');
        // console.log('dlgtrigger', dlgtrigger);
        // console.log('somedialog', somedialog);
        // console.log('dlg', dlg);
    }

    function closedialog() {
        $('.closedialog.action').click();
        $('.audio_player').html('');
    }

    $('.sidefixed').click(function() {
        // console.log('open dialog now 2');
        opendialog();
        var dlgtrigger = document.querySelector('[data-dialog]');
        dlgtrigger.click();
    });


  
    // 
    $('.downloadDialog').on('show.bs.modal', function (event) {
        $('.downloadDialog').parent().find('.success_msg').addClass('d-none').removeClass('d-block d-flex');

        var related = $(event.relatedTarget) // Button that triggered the modal
       if($(related).data('id')){
        $('.downloadDialog .dataToChange').val($(related).data('id'));
       }
    })

    ///  
    $(document).ready(function() {
        var $ = require('jquery');

        if ($('.WeAreOnHomepage').length) {
            // console.log('on home page');
            opendialog();
            var popupaudio = '<audio  autoplay id="playAudio"><source src="' + themeURL + 'media/Jingle-bells.mp3" type="audio/mp3" ver1></audio>'
            popupaudio = '';
            $('.audio_player').html(popupaudio);
        } else {
            // console.log('WeAreNotOnHomepage');
            showgift();
        }
    });
})(window);